import React from 'react';
import { Box, Text } from '@opendoor/bricks/core';

export interface PhotoUploadErrorProps {
  numRequired: number;
  numUploaded: number;
}

/**
 * PhotosUpload renders the photo uploading UI for digital checkout form.
 *
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const PhotoUploadError: React.FC<PhotoUploadErrorProps> = ({ numUploaded, numRequired }) => {
  const missingNumber = numRequired - numUploaded;

  if (numUploaded < numRequired) {
    return (
      <Box mb={4}>
        <Text color="red50">
          Please submit {missingNumber} more photo{missingNumber === 1 ? '' : 's'}
        </Text>
      </Box>
    );
  }
  return null;
};
